<template>
    <div>
        <v-list two-line :min-height="228" :max-height="648" style="overflow-y: auto">
            <template v-for="(item, index) in students">
                <v-list-item link :key="index">
                    <v-list-item-avatar>
                        <v-avatar>
                            <img v-if="$_.has(item, 'profile_photo_url')" :src="item.profile_photo_url" />
                            <v-icon size="48" class="primary--text" v-else>mdi-account-circle</v-icon>
                        </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <div class="d-flex align-center">
                            <div>
                                <v-list-item-title>
                                    {{ item.name }}
                                    <span v-if="$_.has(item, 'order.id')"
                                        class="
                                                                                                                                                text-body-2
                                                                                                                                                font-weight-regular
                                                                                                                                            ">|
                                        Order #
                                        {{
                                            item.order.id }}
                                    </span>
                                    <span>|
                                        {{ item.email }}
                                    </span>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <div class="d-flex align-center mt-1">
                                        <v-chip small :color="$_.get(getStatus(item), 'color')" class="mt-1 text-uppercase"
                                            :class="
                                                $_.get(
                                                    getStatus(item),
                                                    'class',
                                                    ''
                                                )
                                            ">
                                            {{
                                                $_.get(getStatus(item), "label")
                                            }}
                                        </v-chip>

                                        <div class="ml-4">
                                            <template v-for="(menu, index) in getMenuItems(
                                                item
                                            )">
                                                <v-btn :key="`menu-${index}`" :to="$_.get(menu, 'to', null)" v-on="menu.on"
                                                    small :color="menu.color" class="mr-2"><v-icon small class="mr-2">{{
                                                        menu.icon
                                                    }}</v-icon>{{ menu.label }}</v-btn>
                                            </template>
                                        </div>
                                    </div>
                                </v-list-item-subtitle>
                            </div>


                        </div>
                    </v-list-item-content>

                </v-list-item>
                <v-divider class="my-2" :key="`divider-${index}`" v-if="index < students.length - 1"></v-divider>
            </template>
        </v-list>

        <process-print-order v-if="printDialog" :order_id="orderId" v-model="printDialog">
        </process-print-order>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: "student-list",
    components: {
        ProcessPrintOrder: () =>
            import("@components/screen/components/Print/ProcessPrintOrder"),
    },
    props: {
        instructor: {
            type: Object,
            required: true,
        },
        students: {
            type: Array,
            required: true,
        },
        session: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            printDialog: false,
            orderId: null,
        };
    },
    computed: {},
    methods: {
        ...mapActions("Programs", ["instructorInviteStudent"]),
        invite(id) {
            this.instructorInviteStudent(id);
        },
        print(orderId) {
            (this.orderId = orderId), (this.printDialog = true);
        },
        getStatus(student) {
            if (!this.$_.get(student, "meta.registered", false)) {
                return {
                    slug: "registration-pending",
                    label: "Registration Pending",
                    color: "warning",
                    class: "grey--text text--darken-3 font-weight-bold",
                };
            } else {
                switch (this.$_.get(student, "order.status", "ORDER_PENDING")) {
                    case "ORDER_PENDING":
                        return {
                            slug: "report-pending",
                            color: "warning darken-2",
                            label: "Registered - Order Pending",
                        };
                    case "APPLICANT_SUBMITTED":
                        return {
                            slug: "report-pending",
                            color: "info",
                            label: "Report Pending",
                        };
                    case "SCREEN_PENDING":
                    case "SCREEN_IN_PROCESS":
                        return {
                            slug: "report-in-process",
                            color: "secondary",
                            label: "Report In Process",
                        };
                    case "SCREEN_ERROR":
                        return {
                            slug: "report-error",
                            color: "error",
                            label: "Report Error",
                        };
                    case "SCREEN_COMPLETED":
                        return {
                            slug: "report-complete",
                            color: "primary",
                            label: "Report Complete",
                        };
                }
            }
        },
        getMenuItems(student) {
            const { slug } = this.getStatus(student);
            switch (slug) {
                case "registration-pending":
                    return [
                        {
                            icon: "mdi-send",
                            label: "Resend Invite",
                            slug: "resend-invite",
                            on: {
                                click: () => {
                                    this.invite(student.id);
                                },
                            },
                        },
                    ];
                case "report-pending":
                    return this.$_.get(
                        student,
                        "meta.registration_mode",
                        ""
                    ) === "code"
                        ? [
                            {
                                icon: "mdi-clipboard-check",
                                label: "Start Application",
                                slug: "start-application",

                                on: {},
                                to: {
                                    name: "Student Dashboard",
                                    params: {
                                        id: student.id,
                                    },
                                },
                                color: "accent",
                            },
                        ]
                        : [];
                default:
                    return [
                        {
                            icon: "mdi-account",
                            label: "View",
                            slug: "view-student",
                            on: {},
                            to: {
                                name: "Student Dashboard",
                                params: {
                                    id: student.id,
                                },
                            },
                            color: "primary",
                        },
                        {
                            icon: "mdi-file-pdf-box",
                            label: "Print",
                            slug: "print-student",
                            on: {
                                click: () => {
                                    this.print(student.order.id);
                                },
                            },
                            color: "secondary",
                        },
                    ];
            }
        },
    },
};
</script>

<style scoped></style>